import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'

import EN from './locale/en.json'
import KY from './locale/ky.json'
import RU from './locale/ru.json'

export const DefaultLanguage = 'ru'

const supportedLanguages = ['ru', 'ky', 'en']

const getInitialLanguage = () => {
  const lang = new URLSearchParams(window.location.search).get('lang')

  return lang && supportedLanguages.includes(lang) ? lang : DefaultLanguage
}

i18n.use(initReactI18next).init({
  debug: false,
  lng: getInitialLanguage(),
  fallbackLng: DefaultLanguage,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    ru: {
      translation: RU,
    },
    ky: {
      translation: KY,
    },
    en: {
      translation: EN,
    },
  },
})

export default i18n
